/** Cryptographically secure random integer in `[0, max)`. */
export function secureRandomInt(max: number): number {
  if (!Number.isInteger(max) || max <= 0) {
    throw new RangeError('max must be a positive integer');
  }
  const arr = new Uint32Array(1);
  crypto.getRandomValues(arr);
  return arr[0]! % max;
}

function randomUuidFromGetRandomValues(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Generate a random ID using Web Crypto. Prefers `randomUUID()` when present;
 * falls back to a v4 UUID built from `getRandomValues()` for older runtimes.
 */
export function secureRandomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return randomUuidFromGetRandomValues();
  }
  throw new Error('Secure random ID generation requires Web Crypto');
}

/** Short random suffix suitable for client-generated correlation IDs. */
export function secureRandomIdSuffix(length = 7): string {
  return secureRandomId().replace(/-/g, '').slice(0, length);
}
